import { Component, OnInit } from '@angular/core';
import { ProductService, OrderService, DeclinationService, VariationService, Declination, Order, Product, Variation } from 'octali-lib-shop';
import { DisplayerService } from 'octali-lib-utils';
import { combineLatest } from 'rxjs';

import * as moment from 'moment';
import { OrderDetailPage } from '../order/order-detail/order-detail.page';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.page.html',
  styleUrls: ['./orders.page.scss'],
})
export class OrdersPage implements OnInit {

  public orders: Array<Order>;
  private productsId: Map<string,Product>;
  private declinationsId: Map<string,Declination>;
  private variationsId: Map<string,Variation>;

  constructor(
    private productService:ProductService,
    private declinationService: DeclinationService,
    private variationService: VariationService,
    private orderService:OrderService,
    private displayer:DisplayerService
  ) { 
    combineLatest( [
      this.productService.getProductsByIdObs(),
      this.declinationService.getDeclinationsByIdObs(),
      this.variationService.getVariationsIdObs(),
      this.orderService.getOrders$()
    ]).subscribe( ([productsId, declinationsId, variationsId, orders]) => {
      if( productsId && declinationsId && variationsId && orders ){
        this.orders = orders;
        this.productsId = productsId;
        this.declinationsId = declinationsId;
        this.variationsId = variationsId;
      }
    })
  }

  getDate(date){
    return moment.utc(parseInt(date)).format("DD/MM/YYYY");
  }

  getTime(date){
    return moment.utc(parseInt(date)).format("DD/MM/YYYY HH:mm");
  }

  getStatutName( statuts ){
    let statutNames = this.orderService.getStatutNames();
    if(statuts || statuts.length>0){
      if(statuts[statuts.length-1])
        return statutNames.get(statuts[statuts.length-1].name);
      else
      return "";
    }else
      return "";
  }

  ngOnInit() {
  }

  cancel(order){
    this.displayer.presentAlertMultipleButtons("Êtes vous sûr de vous?","Confirmation","Vous êtes sur le point d'annuler votre commande. Confirmez vous?",["oui","non"]).then(async result => {
      if( result =="oui"){
        /*await this.displayer.presentLoader();
        this.orderService.deleteOrder( order ).then( async res => {
          console.log("ok");
          await this.displayer.dismissLoader();
        }).catch( async err => {
          console.log("nok");
          await this.displayer.dismissLoader();
        })*/
        await this.displayer.presentLoader();
        this.orderService.cancelOrder( order ).then( async res => {
          console.log("ok");
          await this.displayer.dismissLoader();
        }).catch( async err => {
          console.log("nok");
          await this.displayer.dismissLoader();
        })  


        /*await this.orderService.getOrdersById(order.id, true).then(async odr => {
          for(let prod of odr.products){
            if(prod[0] instanceof Product){
              let p = await this.productService.getProductById(prod[0].id)
              p.quantity += prod[1];
              this.productService.setProduct(p,false);
            }
            if(prod[0] instanceof Declination){
              let p = await this.productService.getCombinationById(prod[0].id)
              p.quantity += prod[1];
              this.productService.setCombination(p,false);
            }
          }
          order.setStatut({name:"canceled",date:moment.now().toString()});
          odr.setStatut({name:"canceled",date:moment.now().toString()});
          this.orderService.setOrder(odr).then(async order => {
            await this.displayer.dismissLoader();
            this.displayer.presentAlert("Annulation de commande","cpmmande n°"+order.id,"Votre commande a bien été annulée.");
          });
          
        })*/
      }
    }); 
  }

  canCancel(order){
    let states:Array<string> = ["waitingPayment","checking","created","paid","restocking"];
    if( order.statuts[order.statuts.length-1] )
      return states.includes(order.statuts[order.statuts.length-1].name);
    else
      return true;
  }

  viewDetails( order ){
    console.log("view",order);
   this.displayer.presentModal(OrderDetailPage,{order:order});
  }
}


